<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Connect Locks'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }

    @if (loaded) {
      <tidy-row>
        <tidy-text
          [body]="'What would you like to do?'" />
      </tidy-row>

      @if (hasIntegration) {
        <tidy-card>
          <tidy-card-button (action)="goToManageAssignments()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/lock-closed-outline.svg'"
                class="header-size" />
              <tidy-text [header]="'Update Existing Assignments'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Pick a property and choose which of your connected locks belong to it.'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }

      <tidy-card>
        <tidy-card-button (action)="goToConnectSeam()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/add-outline.svg'"
              class="header-size" />
            <tidy-text [header]="'Add/Edit Seam Connections'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Link another smart lock account or disable an existing one.'" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
